import { Dayjs } from 'dayjs';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { LoadCycle } from '~hooks/useLoad/models';
import type { LocationHistoryMinimal } from '~hooks/useLocationHistory/models';

type LoadTimelineSegment = {
  start: Dayjs;
  end: Dayjs;
  id: string;
};

type HoveredLoadStats = {
  loadId: string;
  loadNumber: number;
  cycleSeconds: number | null;
};

export default function useHoveredLoadStats(
  currentPing: LocationHistoryMinimal | null,
  loadSegments: LoadTimelineSegment[],
  loadCycles: LoadCycle[] | undefined,
): HoveredLoadStats | null {
  return useMemo(() => {
    const loadId = currentPing?.loadId;
    if (!loadId) return null;

    const segmentIndex = loadSegments.findIndex((segment) => segment.id === loadId);
    if (segmentIndex === -1) return null;

    const cycle = loadCycles?.find((c) => c.fromLoadId === loadId) ?? null;

    const cycleTimeMinutes = cycle?.timeMinutes;
    const cycleSeconds =
      !isNil(cycleTimeMinutes) && cycleTimeMinutes > 0 ? cycleTimeMinutes * 60 : null;

    return {
      loadId,
      loadNumber: segmentIndex + 1,
      cycleSeconds,
    };
  }, [currentPing?.loadId, loadSegments, loadCycles]);
}
